import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { SafetyObservationsViewContractorsFilters } from './safety-observations-view-contractors-filter.interface';
import { UtilsService } from '../../shared/utils.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-safety-observations-view-contractors-filter',
  templateUrl: './safety-observations-view-contractors-filter.component.html',
  styleUrls: ['./safety-observations-view-contractors-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SafetyObservationsViewContractorsFilterComponent
  implements OnInit {
  filters: SafetyObservationsViewContractorsFilters = {
    industry: '',
    industries: []
  } as SafetyObservationsViewContractorsFilters;

  constructor(
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<
      SafetyObservationsViewContractorsFilterComponent
    >
  ) {}

  ngOnInit(): void {
    // Get Industries
    this.getIndustries();

    this.filters.industry = this.data['industry'];
  }

  private async getIndustries() {
    this.filters.industries = await this.utils.getIndustries();
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the filters.
    this.filters.industry = '';

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    let response: any;

    response = {
      industry: this.filters.industry
    };

    this.dialogRef.close(response);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
